import UpdateRowCard from 'components/panels/update/cards/update.row.card'

const UpdateTableCard = ({ classification, items, onValueChange }) => {



      if (items.length === 0) {
    return null;
  }

    return (
        <div className=' margin-top-large'>        
            <p className="regular o80">{classification}</p>
            <div className="form-group ">
                {items.map((item,index) => (
                    <UpdateRowCard
                        key={index}
                        item={item}
                        value={item.valuation}
                        onValueChange={value => onValueChange(item.id, value)}
                    />
                ))}
            </div>
            </div>
   

     

    )
}

export default UpdateTableCard